/**
 * What the PATIENT said "สนใจ" to on the SMS confirmation page. patient_portal's
 * `functions/api/appt-upsell.js` appends the offer name to `appointment.upsell_detail`.
 *
 * `upsale` is NOT this signal: it is true on ~384k appointments because staff flip
 * the drawer's Upsale toggle. `upsell_detail` is written by the portal and nothing
 * else (checked against live data 2026-09-11), so a non-empty list means the patient
 * asked for it themselves.
 *
 * Rows written before 2026-09-11 carry the long form
 * `Zoom! · ฿8,900 · คนไข้สนใจจาก SMS ยืนยันนัด 11/09/2569`. Cut it at the PRICE token,
 * never at the first " · " — two offer names contain one ("Byebye Braces · Zoom!").
 */
export const UPSELL_MARK = '✨'

const LEGACY = /^(.+?) · (?:฿[\d,]+|สอบถามราคา) · /

/** Short, de-duplicated tag labels for one appointment row. */
export function upsellTags(appt) {
  const list = Array.isArray(appt?.upsell_detail) ? appt.upsell_detail : []
  const out = []
  for (const raw of list) {
    const s = String(raw ?? '').trim()
    if (!s) continue
    const tag = (s.match(LEGACY)?.[1] || s).trim()
    if (!out.includes(tag)) out.push(tag)
  }
  return out
}

/** The chips for the appointment tables. Renders nothing for an empty list. */
export default function UpsellTags({ tags, className = '' }) {
  if (!tags?.length) return null
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`}>
      {tags.map((t) => (
        <span key={t} title={`คนไข้สนใจอัปเกรด: ${t} (จาก SMS ยืนยันนัด)`}
          className="inline-flex items-center gap-0.5 rounded-full bg-fuchsia-50 text-fuchsia-700 ring-1 ring-fuchsia-200 px-1.5 py-0.5 text-[11.5px] font-medium whitespace-nowrap">
          <span aria-hidden="true">{UPSELL_MARK}</span>{t}
        </span>
      ))}
    </span>
  )
}
